import Logo from "./Logo";
import { useLang } from "@/context/LanguageContext";
import { scrollToId } from "@/lib/scroll";
import { BRANDS_DATA } from "@/constants/images";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-[#040d16]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2 lg:max-w-sm">
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-slate-400">{t.footer.blurb}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {t.footer.services.map((s, i) => (
              <span
                key={i}
                className="rounded-full border border-white/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] text-slate-400"
                data-testid={`footer-service-${i}`}
              >
                {s}
              </span>
            ))}
          </div>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-steel">
            {t.form.contactLabels.visit}
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-300" data-testid="footer-address">
            {t.form.address}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-steel" data-testid="footer-serving">
            <i className="fa-solid fa-location-dot mr-2 text-xs text-crimson" />
            Serving Maharashtra · Goa · Belgavi
          </p>
          <div className="mt-4 space-y-1">
            <a
              href="tel:+919594640444"
              data-testid="footer-phone-0"
              className="block text-sm text-slate-300 transition-colors hover:text-steel"
            >
              <i className="fa-solid fa-phone mr-2 text-xs text-crimson" />+91 95946 40444
            </a>
            <a
              href="tel:+918828818444"
              data-testid="footer-phone-1"
              className="block text-sm text-slate-300 transition-colors hover:text-steel"
            >
              <i className="fa-solid fa-phone mr-2 text-xs text-crimson" />+91 88288 18444
            </a>
            <a
              href="mailto:md@teknik.net.in"
              data-testid="footer-email"
              className="block text-sm text-slate-300 transition-colors hover:text-steel"
            >
              <i className="fa-solid fa-envelope mr-2 text-xs text-crimson" />md@teknik.net.in
            </a>
          </div>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-steel">
            {t.footer.principalsLabel}
          </div>
          <ul className="mt-4 space-y-2">
            {BRANDS_DATA.map((b) => (
              <li key={b.id}>
                <a
                  href="#brands"
                  data-testid={`footer-principal-${b.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToId("#brands");
                  }}
                  className="text-sm text-slate-300 transition-colors hover:text-white"
                >
                  {b.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 py-6 text-center sm:flex-row sm:px-8 sm:text-left">
          <p className="font-mono text-[11px] text-slate-500" data-testid="footer-rights">
            © {year} Teknik Enterprises. {t.footer.rights}
          </p>
          <p className="font-mono text-[11px] text-slate-600">Serving Maharashtra · Goa · Belgavi</p>
        </div>
      </div>
    </footer>
  );
}
